import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/teammates")({
  beforeLoad: async ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["TEAMMATE_VIEW"]);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <Outlet />,
});

export { Route };
